import { cn } from '@/utils/cn'
import React from 'react'

export default function SubTitle({children, className, color = "dark"}: {children: React.ReactNode, className?: string, color?: "dark" | "light"}) {
  return (
    <h4 className={cn("text-sm lg:text-base", color === "dark" ? "text-zinc-800" : "text-white", className)}>
        {children}
    </h4>
  )
}